import React, { useState } from "react";
import { getOptionGreekChart } from "../../Requests/optionGreek";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import Cell from "../TableTemplate/Cell";
import { IExtraTypeUIProps } from "../TableTemplate/tableTemplate";
import {
  IChartCommonSearchParam,
  IOptionsGreekTableReport,
} from "../../Interfaces/optionGreek";
import { Graph_Dto } from "../../Interfaces/orderbookGraphInterfaces";
import Modal from "../../Components/Modal/Modal";
import { WrappedTimeSeriesChart } from "../../Components/Timeseries/WrappedTimeSeriesChart";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import DatePicker from "../../Components/DatePicker";
import TimePicker from "../../Components/TimePicker";
import Button from "../../Components/Button";
import moment from "moment";

const WithChartCell = ({
  cellType,
  headerName,
  row,
  translateHeaderName,
}: IExtraTypeUIProps<IOptionsGreekTableReport>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [graphData, setGraphData] = useState<Graph_Dto[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formValues, setFormValues] = useState({
    fromTime: "09:00:00",
    toTime: "12:30:00",
    date: moment().format("YYYY-MM-DD"),
  });

  const [timeISOValues, setTimeISOValues] = useState<{
    fromTime: string | null;
    toTime: string | null;
  }>({
    fromTime: getFromTimeISODefaultValue(),
    toTime: getToTimeISODefaultValue(),
  });

  function getFromTimeISODefaultValue() {
    const defaultFromTime = new Date();
    defaultFromTime.setHours(9, 0, 0, 0);
    return defaultFromTime.toISOString();
  }
  function getToTimeISODefaultValue() {
    const defaultToTime = new Date();
    defaultToTime.setHours(12, 30, 0, 0);
    return defaultToTime.toISOString();
  }

  const getChartHandler = () => {
    setLoading(true);
    setIsModalOpen(false);
    const params: IChartCommonSearchParam = {
      headerName,
      insCode: row.callInstrumentCode,
      insName: row.callInstrument,
      fromTime: formValues.fromTime,
      toTime: formValues.toTime,
      date: formValues.date,
    };
    getOptionGreekChart(params)
      .then((resp) => {
        setGraphData(resp);
        handleCloseMenu();
        setIsModalOpen(true);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const rightClickHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(true);
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
    setAnchorEl(null);
    setIsTooltipOpen(false);
  };

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const timePickerChangeHandler = (
    name: string,
    value: {
      timeString: string;
      ISOString: string | null;
    },
  ) => {
    setTimeISOValues({ ...timeISOValues, [name]: value.ISOString });
    setFormValues({ ...formValues, [name]: value.timeString });
  };

  const getModalUI = () => (
    <div className="h-full w-full min-h-0 flex flex-row items-stretch gap-5 px-4">
      <div className="flex shrink-0 flex-col justify-start items-start gap-3">
        <DatePicker
          label="تاریخ"
          name="date"
          onChange={changeHandler}
          value={formValues.date}
        />
        <TimePicker
          name="fromTime"
          value={timeISOValues.fromTime}
          onChange={timePickerChangeHandler}
          placeholder="از ساعت"
        />
        <TimePicker
          name="toTime"
          value={timeISOValues.toTime}
          onChange={timePickerChangeHandler}
          placeholder="تا ساعت"
        />
        <Button text="جستجو" onClick={getChartHandler} variant="contained" />
      </div>
      <div className="chart-fill-modal">
        <WrappedTimeSeriesChart dataset={graphData} className="h-full w-full" />
      </div>
    </div>
  );

  return (
    <>
      {loading ? <FullScreenLoading /> : <></>}
      {isModalOpen ? (
        <Modal
          onClose={() => {
            handleCloseMenu();
            setIsModalOpen(false);
          }}
          fullScreen
          title={[translateHeaderName || headerName, row.callInstrument]
            .filter(Boolean)
            .join(" — ")}
          UI={getModalUI()}
          modalBoxClassName="!z-[9999]"
        />
      ) : (
        <></>
      )}
      <Tooltip
        title="نمودار"
        className="!w-full !relative"
        open={isTooltipOpen}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
      >
        <div onContextMenu={rightClickHandler} className="ltr">
          <Cell clonedRow={row} headerName={headerName} type={cellType} />
          {isMenuOpen ? (
            <Menu
              className="!z-[9998]"
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleCloseMenu}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={getChartHandler}>نمودار</MenuItem>
            </Menu>
          ) : (
            <></>
          )}
        </div>
      </Tooltip>
    </>
  );
};

export default WithChartCell;
